import {
  Box,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import {
  bgColor25,
  blackShade05,
  blackShade19,
  blueColor04,
  border25,
  borderTextBoxColor,
  greenColor,
  greyColor42,
  greyColor47,
  lightRedColor,
  orangeShade11,
  redColor,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import DeleteIcon from "@mui/icons-material/Delete";
import { textOneLines } from "../../../utils/styles";
import OndcSpecInput from "../../CatalogBulkUploadNewCopy/Components/OndcSpecInput/OndcSpecInput";
import { getOndcErrorCount } from "../../../utils/validateAndPrepareVariant";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { toTitleCase } from "../../../utils/validationUtils";

function VariantOndcForm({
  tableHeader,
  variantData,
  handleValueChange,
  handleChange,
  onDeleteClick,
}) {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  return (
    <Box sx={styles.card}>
      <Typography sx={styles.title}>
        Variance Details ONDC - {variantData?.length} Variants
      </Typography>

      <Box sx={styles.tableWrapper}>
        <TableContainer sx={styles.tableContainer} component={Box}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow
                sx={{
                  position: "sticky !important",
                  top: 0,
                  backgroundColor: greyColor42,
                  zIndex: 20,
                  borderRadius: "8px 8px 0 0",
                }}
              >
                {tableHeader?.map((item, index) => {
                  return (
                    <TableCell
                      key={item.id}
                      sx={
                        matches
                          ? {
                              ...styles.tableCell,
                              ...styles.colSticky(
                                variantData?.[0]?.variant2,
                                variantData?.[0]?.variant3
                              ),
                              padding: "0px",
                            }
                          : { ...styles.tableCell, padding: "0px" }
                      }
                    >
                      <Box
                        display={index === 0 ? "flex" : "inline-block"}
                        alignItems="center"
                        gap={1.2}
                        p="8px 15px"
                      >
                        <Box sx={{ fontSize: 12, textTransform: "uppercase" }}>
                          {item?.title}{" "}
                          {item?.isRequired && (
                            <span style={{ color: "red" }}>*</span>
                          )}
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          width: "100%",
                          bgcolor: bgColor25,
                          fontSize: 11.5,
                          fontWeight: 400,
                          color: orangeShade11,
                          p: "3px 15px",
                        }}
                      >
                        {item?.hint || "-"}
                      </Box>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            {console.log("variantData", variantData)}
            <TableBody sx={{ backgroundColor: whiteColor }}>
              {variantData?.map((productInfo, index) => (
                <TableRow
                  sx={{
                    borderBottom: `1px solid ${borderTextBoxColor}`,
                    verticalAlign: "top",
                  }}
                >
                  <TableCell
                    sx={
                      matches
                        ? {
                            ...styles.tableStickyLeftCell,
                          }
                        : styles.tableBodyCell(false)
                    }
                  >
                    <Typography
                      variant="body1"
                      title={productInfo?.variant1?.inputValue}
                      sx={{ ...styles.prodNameBox, ...textOneLines }}
                    >
                      {productInfo?.variant1?.type === "codeValue"
                        ? toTitleCase(productInfo?.variant1?.inputValue)
                        : productInfo?.variant1?.inputValue}
                    </Typography>
                  </TableCell>

                  {productInfo?.variant2 && (
                    <TableCell
                      sx={
                        matches
                          ? {
                              ...styles.tableStickyLeft1Cell,
                            }
                          : styles.tableBodyCell(false)
                      }
                    >
                      <Typography
                        variant="body1"
                        title={productInfo?.variant2?.inputValue}
                        sx={{ ...styles.prodNameBox, ...textOneLines }}
                      >
                        {productInfo?.variant2?.type === "codeValue"
                          ? toTitleCase(productInfo?.variant2?.inputValue)
                          : productInfo?.variant2?.inputValue}
                      </Typography>
                    </TableCell>
                  )}
                  {productInfo?.variant3 && (
                    <TableCell sx={styles.tableStickyLeft2Cell}>
                      <Typography
                        variant="body1"
                        title={productInfo?.variant3?.inputValue}
                        sx={{ ...styles.prodNameBox, ...textOneLines }}
                      >
                        {productInfo?.variant3?.type === "codeValue"
                          ? toTitleCase(productInfo?.variant3?.inputValue)
                          : productInfo?.variant3?.inputValue}
                      </Typography>
                    </TableCell>
                  )}

                  {productInfo?.specList?.map((specItemInfo, specIndex) => {
                    if (specItemInfo?.display?.toLowerCase() == "n")
                      return null;

                    return (
                      <OndcSpecInput
                        key={`spec_data${specIndex}`}
                        value={specItemInfo?.inputValue}
                        specItemInfo={specItemInfo}
                        // disabled
                        errorMsg={specItemInfo?.error}
                        onChange={(value, selector) => {
                          handleChange(index, specIndex, value, selector);
                        }}
                      />
                    );
                  })}

                  <TableCell
                    sx={
                      matches
                        ? {
                            ...styles.tableStickyLeftCell,
                            ...styles.tableStickyRightCell,
                          }
                        : styles.tableBodyCell(false)
                    }
                  >
                    <Box
                      minWidth="50px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      gap={0.5}
                    >
                      <Stack alignItems="center" justifyContent="center">
                        {productInfo?.specificationError &&
                        getOndcErrorCount(productInfo?.specList || []) > 0 ? (
                          <Box sx={styles.errorCountTag}>
                            {getOndcErrorCount(productInfo?.specList || [])}
                          </Box>
                        ) : (
                          <CheckCircleIcon
                            sx={{ fontSize: 16, color: greenColor }}
                          />
                        )}
                      </Stack>
                      <IconButton
                        size="small"
                        onClick={() => onDeleteClick(index)}
                      >
                        <DeleteIcon
                          sx={{ fontSize: "16px", color: redColor }}
                        />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
}

export default VariantOndcForm;

const styles = {
  card: {
    backgroundColor: whiteColor,
    borderRadius: "13px",
    border: border25,
    boxShadow: "0 3px 4px rgb(229 233 240 / 22%)",
    p: "15px 15px 15px",
    mb: 2,
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: "20px",
    mb: "10px",
    color: blackShade19,
  },
  actionBtn: {
    backgroundColor: blueColor04,
    padding: "2px 10px",
    fontSize: "12px",
    fontWeight: 500,
    color: whiteColor,
    border: "1px solid " + blueColor04,
    "&:hover": {
      color: blueColor04,
      backgroundColor: whiteColor,
    },
  },
  tableWrapper: {
    width: { md: "calc(100vw - 310px)", xs: "100%" },
    borderRadius: "8px",
    border: `1px solid ${borderTextBoxColor}`,
  },

  tableContainer: {
    borderRadius: "8px",
    overflow: "scroll",
    maxHeight: "calc(100vh - 370px)",
    maxWidth: "100%",
    "&::-webkit-scrollbar": {
      width: "4px",
      height: "4px",
      borderRadius: "50px !important",
    },
    "&::-webkit-scrollbar-thumb": {
      // background: '#d0d3da',
      background: "rgba(0,0,0,0.1)",
    },
    "&::-webkit-scrollbar-track": {
      background: "rgba(0,0,0,0.05)",
    },
  },

  tableCell: {
    color: greyColor47,
    fontSize: "12.5px",
    fontWeight: "500",
    whiteSpace: "nowrap",
    padding: "8px 15px",
    backgroundColor: greyColor42,
    borderRight: `1px solid ${whiteColor}`,
  },

  colSticky: (sticky1, sticky2) => ({
    ":first-child": { position: "sticky", left: "0px" },
    ":nth-child(2)": sticky1
      ? {
          position: "sticky",
          left: "150px",
          boxShadow: `-1px 0 0 0 ${whiteColor} inset ,1px 0 0 0 ${whiteColor} inset`,
        }
      : "",
    ":nth-child(3)": sticky2
      ? {
          position: "sticky",
          left: "300px",
          boxShadow: `-1px 0 0 0 ${whiteColor} inset ,1px 0 0 0 ${whiteColor} inset`,
        }
      : "",

    ":last-child": { position: "sticky", right: "-3px" },
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset `,
  }),

  statuSticky: (isStatus) => ({
    right: isStatus ? "100px" : "unset",
  }),

  colStickyRight: (isSticky) => ({
    position: "-webkit-sticky",
    position: isSticky ? "sticky" : "unset",
    width: isSticky ? "100px" : "auto",
    minWidth: isSticky ? "100px" : "auto",
    maxWidth: isSticky ? "100px" : "auto",
    right: "0px",
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset`,
  }),

  tableBodyCell: (isError) => ({
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: isError ? lightRedColor : whiteColor,
    padding: "8px 15px !important",
    borderRight: `1px solid ${borderTextBoxColor}`,

    boxShadow: isError ? `0px -1px 0 0 ${redColor} inset` : "none",
  }),

  tableStickyLeftCell: {
    width: "150px !important",
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: whiteColor,
    padding: "10px 15px !important",
    position: "sticky",
    left: 0,
    zIndex: 10,
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset`,
  },
  tableStickyLeft1Cell: {
    width: "150px !important",
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: whiteColor,
    padding: "10px 15px !important",
    position: "sticky",
    left: "150px",
    zIndex: 10,
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset ,1px 0 0 0 ${borderTextBoxColor} inset`,
  },
  tableStickyLeft2Cell: {
    width: "150px !important",
    fontSize: 13,
    fontWeight: 500,
    whiteSpace: "nowrap",
    color: blackShade05,
    backgroundColor: whiteColor,
    padding: "10px 15px !important",
    position: "sticky",
    left: "300px",
    zIndex: 10,
    boxShadow: `-1px 0 0 0 ${borderTextBoxColor} inset ,1px 0 0 0 ${borderTextBoxColor} inset`,
  },

  tableStickyRightCell: {
    position: "sticky",
    right: 0,
    boxShadow: `1px 0 0 0 ${borderTextBoxColor} inset`,
  },
  errorCountTag: {
    backgroundColor: lightRedColor,
    color: redColor,
    fontSize: 12,
    fontWeight: 600,
    p: "3px 18px",
    borderRadius: "10px",
  },

  deleteBtn: {
    fontSize: 13,
    fontWeight: 500,
    color: whiteColor,
    p: "4px 30px",
    border: `1.5px solid ${redColor}`,
    backgroundColor: redColor,
    "&:hover": {
      color: redColor,
      backgroundColor: whiteColor,
    },
  },
  prodNameBox: {
    minWidth: "120px",
    maxWidth: "120px",
    whiteSpace: "normal",
    fontSize: 12,
    fontWeight: 600,
    color: blackShade19,
    lineHeight: "16px",
  },
};
